import { defineComponent as _defineComponent } from 'vue'
import HyreCardsBg from '~/assets/img/HyreCardsBg.svg'
import SignUpBackgroundHyreIcon from '~/assets/img/SignUpBackgroundHyreIcon.svg'
import { useContext } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'GetStartedModal',
  emits: ["skip"],
  setup(__props) {



const {
  $app: { analytics },
} = useContext()

return { __sfc: true,analytics, HyreCardsBg, SignUpBackgroundHyreIcon }
}

})